module.exports = __webpack_public_path__ + "static/media/teacher-student.00131f73.jpeg";